module.exports = __webpack_public_path__ + "static/img/mwInspection.b9016983.png";